import Constant from '@/const';
import axios from 'axios';

const putDrugs = async (id, payload) => {
  try {
    const response = await axios.put(
      Constant.apiUrl.concat(`/master/drugs/${id}`),
      payload,
    );
    return response;
  } catch (error) {
    this.showErrorAxios(error);
  }
};

export default putDrugs;
